function TableHeader() {
    return (
        <thead>
            <tr>
                <th className="border border-gray-400 p-2">Navn</th>
                <th className="border border-gray-400 p-2">Udbyder</th>
                <th className="border border-gray-400 p-2">Formål</th>
                <th className="border border-gray-400 p-2">Udløber</th>
                <th className="border border-gray-400 p-2">Type</th>
            </tr>
        </thead>
    )
}

function BaseTable({ children }) {
    return (
        <table
            className="border text-xs"
        >
            <TableHeader />
            {children}
        </table>
    )
}

export default BaseTable